<template>
  <div class="chat_box">
    <div class="prof seller">
      <div class="inner">
        <img
          src="@/assets/front/images/v2/profiles/img_perce_prof_w.png"
          alt=""
        />
      </div>
    </div>
    <div class="chat_con perce_chat_con">
      <div class="chat_txt" v-if="mobileDealModel.dealCd == 'OCB_2503'">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          안녕하십니까!<br />
          OK Cash Back과 함께하는 퍼스 공식 인증매장입니다.
        </div>
        <div class="chat_msg system">
          개통을 원하시면 신청서를 작성해 주시고, 궁금한 점이 있으시면 메시지를
          남겨 주세요. 매장에서 확인 후 답변을 드립니다.
        </div>
      </div>
      <div
        class="chat_txt"
        v-else-if="mobileDealModel.dealCd == 'HANAPAY_2503'"
      >
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          안녕하십니까!<br />
          하나페이와 함께하는 퍼스 공식 인증매장입니다.
        </div>
        <div class="chat_msg system">
          개통을 원하시면 신청서를 작성해 주시고, 궁금한 점이 있으시면 메시지를
          남겨 주세요. 매장에서 확인 후 답변을 드립니다.
        </div>
      </div>
      <div class="chat_txt" v-else>
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          안녕하십니까!<br />
          퍼스특가 공식 인증매장입니다.
        </div>
        <div class="chat_msg system">
          개통을 원하시면 신청서를 작성해 주시고, 궁금한 점이 있으시면 메시지를
          남겨 주세요. 매장에서 확인 후 답변을 드립니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    mobileDealModel: Object,
  },
  data() {
    return {};
  },
  mounted() {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      console.log('valvalvalvalvalval');
      console.log(val);

      var data = String(val)
        .split('\n')
        .join('<br />');

      console.log(data);
      return data;
    },
  },
  methods: {
    _toBR(str) {
      return util.toBR(str);
    },
  },
};
</script>

<style></style>
